import cn from './cn.json';
import en from './en.json';
import jp from './jp.json';
import tw from './tw.json';

export const messages = {
    cn,
    en,
    jp,
    tw,
};
